import React, { PureComponent, Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import { CreateBundle, EditBundle, ListBundles } from "./Bundles/lazy-components";
import { CreateLicenseBundle, EditLicenseBundle, ListLicenseBundles } from "./LicenseBundles/lazy-components";
import { ListFeatures, CreateFeature, EditFeature } from "./Features/lazy-components";
import { ListProducts, CreateProduct, EditProduct, CloneProduct } from "./Products/products-lazy-components";
import CustomerPages from "./Customers";
import { ListProductGroups, CreateProductGroup, EditProductGroup } from "./ProductGroups";
import { ListPurchases, CreatePurchase, EditPurchase } from "./Purchases";
import TemplateListPage from "./Templates/TemplateListPage";
import EditTemplate from "./Templates/EditTemplate";
import CreateTemplate from "./Templates/CreateTemplate";
import CustomerGroupListPage from "./CustomerGroups/CustomerGroupListPage";
import EditCustomerGroup from "./CustomerGroups/EditCustomerGroup";
import CreateCustomerGroup from "./CustomerGroups/CreateCustomerGroup";
import DiscountListPage from "./Discounts/DiscountListPage";
import EditDiscount from "./Discounts/EditDiscount";
import CreateDiscount from "./Discounts/CreateDiscount";
import AdminPage from "./Admin/UsersListPage";
import CreateUser from "./Admin/CreateUser";
import EditUser from "./Admin/EditUser";
import DefaultRedirect from "./DefaultRedirect";
import InternalInvoiceListPage from "./InternalInvoices/InternalInvoiceListPage";
import ChangePassword from "./Admin/ChangePassword";

export const routes = {
  templates: "/templates",
  editTemplate: "/templates/:id/edit",
  createTemplate: "/templates/new",
  customerGroups: "/customerGroups",
  createCustomerGroup: "/customerGroups/new",
  editCustomerGroup: "/customerGroups/:id/edit",
  discounts: "/discounts",
  createDiscounts: "/discounts/new",
  editDiscounts: "/discounts/:id/edit",
  users: "/users",
  addUser: "/users/new",
  editUser: "/users/:id/edit",
  changePassword: "/users/change-password"
};
class AppRouting extends PureComponent {
  render() {
    return (
      <Suspense fallback={<div>Loading...</div>}>
        <Switch>
          <Route exact path="/license_bundles">
            <ListLicenseBundles />
          </Route>
          <Route exact path="/license_bundles/new">
            <CreateLicenseBundle />
          </Route>
          <Route exact path="/license_bundles/:slug/edit" render={props => <EditLicenseBundle {...props} />} />
          <Route exact path="/bundles">
            <ListBundles />
          </Route>
          <Route exact path="/bundles/new">
            <CreateBundle />
          </Route>
          <Route exact path="/bundles/:slug/edit" render={props => <EditBundle {...props} />} />
          <Route exact path="/features">
            <ListFeatures />
          </Route>
          <Route exact path="/features/:slug/edit" render={props => <EditFeature {...props} />} />
          <Route path="/features/new">
            <CreateFeature />
          </Route>
          <Route exact path="/products">
            <ListProducts />
          </Route>
          <Route exact path="/products/new">
            <CreateProduct />
          </Route>
          <Route exact path="/products/:slug/edit" render={props => <EditProduct {...props} />} />
          <Route exact path="/products/:slug/clone" render={props => <CloneProduct {...props} />} />

          <Route exact path="/customers" render={props => <CustomerPages.List {...props} />} />
          <Route exact path="/customers/:slug" render={props => <CustomerPages.Detail {...props} />} />

          <Route exact path={routes.customerGroups} render={props => <CustomerGroupListPage {...props} />} />
          <Route exact path={routes.editCustomerGroup} render={props => <EditCustomerGroup {...props} />} />
          <Route exact path={routes.createCustomerGroup} render={props => <CreateCustomerGroup {...props} />} />

          <Route exact path="/productGroups">
            <ListProductGroups />
          </Route>
          <Route exact path="/productGroups/new">
            <CreateProductGroup />
          </Route>
          <Route exact path="/productGroups/:slug/edit" render={props => <EditProductGroup {...props} />} />

          <Route exact path="/purchases/:id/edit" render={props => <EditPurchase {...props} />} />
          <Route exact path="/purchases/new" render={props => <CreatePurchase {...props} />} />
          <Route exact path="/purchases" render={props => <ListPurchases {...props} />} />

          <Route exact path="/invoices" render={props => <InternalInvoiceListPage {...props} />} />
          <Route exact path={routes.templates} render={props => <TemplateListPage {...props} />} />
          <Route exact path={routes.editTemplate} render={props => <EditTemplate {...props} />} />
          <Route exact path={routes.createTemplate} render={props => <CreateTemplate {...props} />} />

          <Route exact path={routes.discounts} render={props => <DiscountListPage {...props} />} />
          <Route exact path={routes.editDiscounts} render={props => <EditDiscount {...props} />} />
          <Route exact path={routes.createDiscounts} render={props => <CreateDiscount {...props} />} />

          <Route exact path={routes.addUser} render={props => <CreateUser {...props} />} />
          <Route exact path={routes.editUser} render={props => <EditUser {...props} />} />
          <Route exact path={routes.changePassword} render={props => <ChangePassword {...props} />} />
          <Route exact path={routes.users} render={props => <AdminPage {...props} />} />

          <Route component={DefaultRedirect} />
        </Switch>
      </Suspense>
    );
  }
}

export default AppRouting;
